import { call, take, put }   from 'redux-saga/effects';
import axios                 from 'axios';
import { SET_BAD_TEACHER_ID,
         SET_NEW_TEACHER_ID
       }                     from '../actions';



const endpoint = 'api/setTeacherId.php';

function* setTeacherId(): Generator<any,any,any> {
    while(true) {
      try {
        const input = yield take('SUBMIT_CODE_SAGA');

        if (process.env.NODE_ENV === 'development') {
          yield put(SET_NEW_TEACHER_ID(100))
          return
        }

        const { userEmail, code } = input.payload

        const response = yield call(
          axios.post,
          endpoint,
          {
             userEmail: userEmail,
             newTeacherId: code
          }
        )

        console.log('set teacher id response       :   ',response)
        console.log('set teacher id response.data  :   ',response.data)

        if (!response.data.success) {
          yield put(SET_BAD_TEACHER_ID())
        }
        else {
          yield put(SET_NEW_TEACHER_ID(code))
        }
      }
      catch (err) { console.log('err  :  '+err); }
      finally {}
    }
  }

export default setTeacherId;
